import { Box, Grid } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { AsterChip } from 'asterX-UI/Chip'
import { getDaysLabel } from 'lib/utils'
import React from 'react'

export const completedColumns = (isAdmin = false, homeStoreFunc) => {
  if (isAdmin) {
    return [
      '№',
      'Тип просрочки',
      'Клиент',
      'LEVEL',
      'Менеджер	',
      'Филиал shinhan',
      'Продукт',
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('loanAmount')}>
        Сумма займа {homeStoreFunc.getArrow('loanAmount')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('overdueDays')}>
        Дни просрочки {homeStoreFunc.getArrow('overdueDays')}
      </Box>,
      <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueTranchesSum')}>
        Сумма просрочки {homeStoreFunc?.getArrow('overdueTranchesSum')}
      </Box>,
      ''
    ]
  }
  return [
    '№',
    'Тип просрочки',
    'Клиент',
    'LEVEL',
    'Филиал shinhan',
    'Продукт',
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('loanAmount')}>
      Сумма займа {homeStoreFunc.getArrow('loanAmount')}
    </Box>,
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc.handleSort('overdueDays')}>
      Дни просрочки {homeStoreFunc.getArrow('overdueDays')}
    </Box>,
    <Box style={{ cursor: 'pointer' }} onClick={() => homeStoreFunc?.handleSort('overdueTranchesSum')}>
      Сумма просрочки {homeStoreFunc?.getArrow('overdueTranchesSum')}
    </Box>,
    ''
  ]
}

export const completedRows = (list, isAdmin) => {
  if (!list) {
    return []
  }

  return list?.map(item => {
    const row = [
      item?.contractNumber,
      <AsterChip label={item?.overdueType} />,
      item?.clientFullName?.replace('null', '').trim() || '-',
      <Grid style={{display:'flex', justifyContent:'center', alignItems:'center'}}>{item?.level || '-'}</Grid>,
      item?.subdivisionName || '-',
      item?.creditProductName || '-',
      item?.loanAmount?.toString()?.thousandSeparator() || '-',
      <Grid item>{`${item?.overdueDays || 0} ${getDaysLabel(item?.overdueDays)}`}</Grid>,
      item?.overdueTranchesSum?.toString()?.thousandSeparator() || '-',
      {
        isButton: true,
        label: <ChevronRight />,
        data: { id: item?.id }
      }
    ]

    if (isAdmin) {
      row.splice(4, 0, item?.assignToFullName || '-')
    }

    return row
  })
}
